import PropTypes from "prop-types";
import { ReactComponent as ExpandMore } from "../../../../assets/img/icon/expand_more_black_24dp.svg";

const ExpandData = (props) => {
  const handleMoreData = () => {
    if (props.handleMoreData) props.handleMoreData();
  };
  return (
    props.page !== props.tpage && (
      <>
        {!props.loading && props.tpage !== 0 && (
          <div className="mt-8 cursor-pointer" onClick={handleMoreData}>
            <div className="text-center xl:text-left text-primary">
              Muat lebih banyak
            </div>
            <div className="block xl:hidden -mt-1">
              <ExpandMore className="w-8 h-8 mx-auto fill-current text-primary" />
            </div>
          </div>
        )}
      </>
    )
  );
};

ExpandData.propTypes = {
  page: PropTypes.number.isRequired,
  tpage: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  handleMoreData: PropTypes.func.isRequired,
};
export default ExpandData;
